var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProcess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0007 14V12H7.33398V5.33333H6.00065V7.33333H1.33398V2H6.00065V4H10.0007V2H14.6673V7.33333H10.0007V5.33333H8.66732V10.6667H10.0007V8.66667H14.6673V14H10.0007ZM11.334 6H13.334V3.33333H11.334V6ZM11.334 12.6667H13.334V10H11.334V12.6667ZM2.66732 6H4.66732V3.33333H2.66732V6Z",
    fill: "#5F6368",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProcess);
export default __webpack_public_path__ + "static/media/process.52d2599c234056055dc892d53abfca5c.svg";
export { ForwardRef as ReactComponent };